import { cloneElement, useCallback } from 'react';
import { connect } from 'react-redux';
import { redirectInModal } from '../actions/util';
import { DashboardLinkElement } from '../style';

const DashboardLink = ({ redirect, href, onClick, children, target, ...other }: $TSFixMe) => {
    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            redirect(href);

            if (onClick) {
                onClick(e);
            }
        },
        [onClick, href, redirect]
    );

    return (
        <DashboardLinkElement href={href} target={target} onClick={handleClick} inherit>
            {cloneElement(children, other)}
        </DashboardLinkElement>
    );
};

export default connect(undefined, {
    redirect: redirectInModal,
})(DashboardLink);
